const ITEMS = [
    { text: "$BLASTARDIO", color: "text-white" },
    { text: "NO BRAKES. JUST BLAST.", color: "text-blast-pink" },
    { text: "100% MEME FUEL", color: "text-blast-violet" },
    { text: "PRESALE SOON", color: "text-blast-rose" },
    { text: "ZERO UTILITY. MAXIMUM VELOCITY.", color: "text-white" },
    { text: "JOIN THE CREW", color: "text-blast-pink" },
];

export default function Marquee() {
    return (
        <div className="marquee relative overflow-hidden border-y border-white/10 bg-blast-panel/60 py-5">
            <div className="marquee-track flex w-max items-center">
                {[0, 1].map((copy) => (
                    <div
                        key={copy}
                        aria-hidden={copy === 1}
                        className="flex items-center"
                    >
                        {ITEMS.map((item, i) => (
                            <span
                                key={i}
                                className="flex items-center whitespace-nowrap font-display text-lg font-bold uppercase tracking-wide sm:text-2xl"
                            >
                                <span className={item.color}>{item.text}</span>
                                <span className="mx-8 text-blast-pink/50">
                                    ✦
                                </span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
